export const START_UP = 1
export const ESTABLISHED = 2

const OLD_START_UP = 10001
const OLD_ESTABLISHED = 10002

const companyTypes = new Map()

companyTypes.set(OLD_START_UP, START_UP)
companyTypes.set(OLD_ESTABLISHED, ESTABLISHED)
